import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ROUTE_PATHS } from '../contants/ROUTE_PATHS';

import ProtectedRoute from './protected-route';
import HomePage from '../pages/home-page';
import IndividualRegistrationPage from '../pages/individual-registration-page';
import PlaceHolderPage from '../pages/placeholder-page';
import AboutPage from '../pages/about-page';
import TermsConditionsPage from '../pages/terms-conditions-page';
import PrivacyPolicyPage from '../pages/privacy-policy-page';
import ConnectPage from '../pages/connect-page';
import ForgotInfoPage from '../pages/forgot-info-page';
import UnAuthenticatedPage from '../pages/admin/unauthenticated-request-page';
import UnVerifiedPage from '../pages/admin/unverified-email-page';
import AdminIndexPage from '../pages/admin/index-page';
import FAQPage from '../pages/admin/faq-page';
import AccountSettingsPage from '../pages/admin/account-settings';
import GroupManagementPage from '../pages/admin/group-management';
import LeaderPage from '../pages/admin/leader-page';
import LibraryPage from '../pages/admin/library-page';
import DeleteAccount from '../pages/admin/delete-account';
import ModeratePost from '../pages/admin/moderate-post';
import SharedPost from '../pages/shared-post';

export default function Routes() {
  return (
    <Switch>
      <Route exact path={ROUTE_PATHS.HOME} component={HomePage} />
      <Route exact path={ROUTE_PATHS.INDIVIDUAL_PATH} render={() => <HomePage signUp={true}/>} />
      <Route exact path={ROUTE_PATHS.ABOUT_RELYHT} component={AboutPage} />
      <Route exact path={ROUTE_PATHS.CONNECT} component={ConnectPage} />
      <Route exact path={ROUTE_PATHS.PRIVACY_POLICY} component={PrivacyPolicyPage} />
      <Route exact path={ROUTE_PATHS.TERMS_CONDITIONS} component={TermsConditionsPage} />
      <Route exact path={ROUTE_PATHS.USER_HELP} component={ForgotInfoPage} />
      <Route exact path={ROUTE_PATHS.FAQ_TIPS} component={FAQPage} />
      <Route path={`${ROUTE_PATHS.POSTS}/:id`} component={PlaceHolderPage} />
      <Route exact path={`${ROUTE_PATHS.SHARED}/:id`} component={SharedPost} />

      <Route exact path={ROUTE_PATHS.PROTECTED} component={UnAuthenticatedPage} />
      <Route exact path={ROUTE_PATHS.UNVERIFIED} component={UnVerifiedPage} />

      <ProtectedRoute exact path={ROUTE_PATHS.ADMIN_HOME} component={AdminIndexPage} />
      <ProtectedRoute exact path={ROUTE_PATHS.ADMIN_GROUPS} component={GroupManagementPage} />
      <ProtectedRoute exact path={ROUTE_PATHS.ADMIN_LEADERS} component={LeaderPage} />
      <ProtectedRoute exact path={ROUTE_PATHS.ADMIN_ENGAGEMENT} component={PlaceHolderPage} />
      <ProtectedRoute exact path={ROUTE_PATHS.LIBRARY} component={LibraryPage} />
      <ProtectedRoute exact path={ROUTE_PATHS.DELETE_ACCOUNT} component={DeleteAccount} />
      <ProtectedRoute
        exact
        path={ROUTE_PATHS.ADMIN_USER_SETTINGS}
        component={AccountSettingsPage} />
      <ProtectedRoute exact path={`${ROUTE_PATHS.MODERATE}/:id`} component={ModeratePost} />

      <Route exact path={ROUTE_PATHS.UNDER_CONSTRUCTION} component={PlaceHolderPage} />
    </Switch>
  );
}
